import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../services/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./getting-started/getting-started.component').then((m) => m.GettingStartedComponent),
    children: [
      {
        path: '',
        redirectTo: 'firm-onboarding',
        pathMatch: 'full'
      },
      {
        path: 'firm-onboarding',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./getting-started/firm-onboarding/firm-onboarding.component').then(
            (m) => m.FirmOnboardingComponent),
      },
      {
        path: 'teams-onboarding',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./getting-started/teams-onboarding/teams-onboarding.component').then(
            (m) => m.TeamsOnboardingComponent),
      },
      {
        path: 'client-onboarding',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./getting-started/clients-onboarding/clients-onboarding.component').then(
            (m) => m.ClientsOnboardingComponent),
      },
      // {
      //   path: 'client-integration',
      //   canActivate: [AuthGuard],
      //   loadComponent: () =>
      //     import('./getting-started/client-integration/client-integration.component').then(
      //       (m) => m.ClientIntegrationComponent),
      // },
      {
        path: 'components-onboarding',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./getting-started/components-onboarding/components-onboarding.component').then(
            (m) => m.ComponentsOnboardingComponent),
      },
      {
        path: 'engagement-overview',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./getting-started/engagement-overview/engagement-overview.component').then(
            (m) => m.EngagementOverviewComponent),
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GettingStartedRoutingModule { }
